export const RRS_COMPARE_LOANS = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Sammenligne lån? Vi har gjort jobben for deg!',
  url: 'https://scoopr.no/sammenlign-lan',
  description:
    'Når du skal sammenligne lån finnes det mange muligheter. Faktisk så mange at du risikerer å gå glipp av den beste renten du kan få, fordi du ikke fant banken “din”. Det har vi i Scoopr gjort noe med – når du søker om lån hos oss går søknaden din automatisk ut til 13 banker, som konkurrerer om å gi deg den beste renten.',
  datePublished: '2022-01-21T08:00:00+00:00',
  dateModified: '2022-01-26T08:00:00+00:00',
};
